import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";
import MenuItem from "@mui/material/MenuItem";
import SoftButton from "components/SoftButton";
import { ThemedTrashIcon } from "assets/CXFIcons/Triggers";
import { deleteSchedule } from "redux/actions/flowDesigner/calendarActionCreator";
import { useAllowedPermissions } from "hooks/useAllowedPermissions";
import { PERMISSIONS } from "constants/portal";
import { DeleteScheduleDialog } from "../DeleteScheduleDialog";
import useScheduleInUse from "hooks/useScheduleInUse";

const DeleteScheduleMenuItem = ({ handleClose, selectedEvent, isMenuItem, forcedOpen = false, flows }) => {
   const dispatch = useDispatch();
   const { t } = useTranslation("flowDesigner");
   const { user } = useAuth0();
   const [showDialog, setShowDialog] = useState(false);
   const [isInUse, setIsInUse] = useState(false);
   const { isScheduleInUse, useInFlows, isCheckFailed } = useScheduleInUse();

   const { isAllowedAction } = useAllowedPermissions();

   const closeDeleteDialog = () => {
      setShowDialog(false);
      handleClose();
   };

   const deleteEvent = async () => {
      dispatch(deleteSchedule(user?.stripeId, selectedEvent.id));
      closeDeleteDialog();

      if (!isMenuItem) {
         handleClose();
      }
   };

   const openDialog = async (e) => {
      e.stopPropagation();

      if (isMenuItem && !forcedOpen) {
         handleClose();
      }
      const inUse = await isScheduleInUse(selectedEvent.id, flows);
      setIsInUse(inUse);

      setShowDialog(true);
   };

   return (
      <>
         {isMenuItem ? (
            <MenuItem onClick={openDialog} disabled={!isAllowedAction(undefined, [PERMISSIONS.DELETE_SCHEDULES, PERMISSIONS.DELETE_ANY_SCHEDULES])}>
               {t("buttons.delete")}
            </MenuItem>
         ) : (
            <SoftButton
               sx={{
                  backgroundColor: "transparent !important",
                  boxShadow: "none !important",
                  padding: "6px !important",
                  color: "#E53E3E !important"
               }}
               onClick={openDialog}
            >
               <ThemedTrashIcon color="red" />
               Delete
            </SoftButton>
         )}
         <DeleteScheduleDialog showDialog={showDialog} closeDeleteDialog={closeDeleteDialog} schedule={selectedEvent} deleteSchedule={deleteEvent} isInUse={isInUse} useInFlows={useInFlows} isCheckFailed={isCheckFailed} />
      </>
   );
};

export default DeleteScheduleMenuItem;
